import { Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';


const CookieModal = ({ showModal, handleClose, setVisible }) => {

    const [consent, setConsent] = useState({
        preferences: false,
        advertisement: false,
        functional: false,
        analytics: false,
    });

    useEffect(() => {
        const storedConsent = localStorage.getItem("cookieConsentDetails");
        if (storedConsent) {
            setConsent(JSON.parse(storedConsent));
        }
    }, []);

    const handleSwitchChange = (key) => {
        setConsent(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const handleAccept = () => {
        localStorage.setItem("cookieConsent", "accepted");
        localStorage.setItem("cookieConsentDetails", JSON.stringify(consent));
        setVisible(false)
        handleClose();
    };

    const handleReject = () => {
        localStorage.setItem("cookieConsent", "rejected");
        localStorage.setItem("cookieConsentDetails", JSON.stringify({
            preferences: false,
            advertisement: false,
            functional: false,
            analytics: false
        }));
        setVisible(false)
        handleClose();
    };

    const getCookieDescription = (key) => {
        switch (key) {
            case "preferences":
                return "Preferencee cookies enable website to remember infomartion that changes the way thewebsite behaves or looks, like your preffered language or the region that you are in.";
            case "advertisement":
                return "Preferencee cookies enable website to remember infomartion that changes the way thewebsite behaves or looks, like your preffered language or the region that you are in.";
            case "functional":
                return "Statistic cookies help website owners to understand how visitors interact with websitesby collecting and reporting information anonymously.";
            case "analytics":
                return "Marketing cookies are used to track visitors across webstites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.";
            default:
                return "";
        }
    };

    return (
        <Modal
            show={showModal}
            centered
            className='cookie-modal'
            onHide={handleClose}
        >

            <Modal.Body>

                <div className="first_box">
                    <h5>Privacy Overview</h5>
                    <p>This website uses cookies to improve your experience while you navigate through the website.
                        Out of these, the cookies that are categorized as necessary are stored on your browser as they are essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website. These cookies will be stored in your browser only with your consent. You also have the option to opt-out of these cookies. But opting out of some of these cookies may affect your browsing</p>
                </div>
                <div className="privacy_overview">
                    <div className="overview_box">
                        <h6>Necessary</h6>
                        <div className="switch_view_box">
                            <p>Necessary cookies help make a website usable by enabing basic functions like page navigation and access to secure of the website. The website cannot function properly without these cookies.</p>
                            <div class="swicth_box">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" checked disabled />
                                </div>
                            </div>
                        </div>
                    </div>

                    {['preferences', 'advertisement', 'functional', 'analytics'].map((key) => (
                        <div className="overview_box" key={key}>
                            <h6>{key.charAt(0).toUpperCase() + key.slice(1)}</h6>
                            <div className="switch_view_box">
                                <p>{getCookieDescription(key)}</p>
                                <div class="swicth_box">
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={consent[key]}
                                            onChange={() => handleSwitchChange(key)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* <div className="overview_box">
                        <h6>Preferences</h6>
                        <div className="switch_view_box">
                            <p>Preferencee cookies enable website to remember infomartion that changes the way thewebsite behaves or looks, like your preffered language or the region that you are in.</p>
                            <div class="swicth_box">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overview_box">
                        <h6>Advertisement</h6>
                        <div className="switch_view_box">
                            <p>Preferencee cookies enable website to remember infomartion that changes the way thewebsite behaves or looks, like your preffered language or the region that you are in.</p>
                            <div class="swicth_box">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overview_box">
                        <h6>Functional</h6>
                        <div className="switch_view_box">
                            <p>Statistic cookies help website owners to understand how visitors interact with websitesby collecting and reporting information anonymously.</p>
                            <div class="swicth_box">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overview_box">
                        <h6>Analytics</h6>
                        <div className="switch_view_box">
                            <p>Marketing cookies are used to track visitors across webstites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.</p>
                            <div class="swicth_box">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button class="btn btn_reject" onClick={handleReject}>Reject All</button>
                <button class="btn btn_accept" onClick={handleAccept}>Accept <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00004 1.3335C4.32671 1.3335 1.33337 4.32683 1.33337 8.00016C1.33337 11.6735 4.32671 14.6668 8.00004 14.6668C11.6734 14.6668 14.6667 11.6735 14.6667 8.00016C14.6667 4.32683 11.6734 1.3335 8.00004 1.3335ZM11.1867 6.46683L7.40671 10.2468C7.31337 10.3402 7.18671 10.3935 7.05337 10.3935C6.92004 10.3935 6.79337 10.3402 6.70004 10.2468L4.81337 8.36016C4.62004 8.16683 4.62004 7.84683 4.81337 7.6535C5.00671 7.46016 5.32671 7.46016 5.52004 7.6535L7.05337 9.18683L10.48 5.76016C10.6734 5.56683 10.9934 5.56683 11.1867 5.76016C11.38 5.9535 11.38 6.26683 11.1867 6.46683Z" fill="#171202"></path></svg></button>
            </Modal.Footer>
        </Modal >
    )

}
export default CookieModal